import './polyfill.js';
import { StrictMode, Component } from 'react'
import { createRoot } from 'react-dom/client'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase.js';
import './index.css'
import App from './App.jsx'

// Apply global React DOM patch for unmounted nodes
if (typeof Node !== 'undefined') {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child && child.parentNode !== this) {
      console.warn('Talisman Widget Patch: React attempted to remove a node that is not a child. Suppressing crash.');
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };
  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('Talisman Widget Patch: React attempted to insert before a node that is not a child. Suppressing crash.');
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
class GlobalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Global Widget Error:", error, errorInfo);
    try {
      addDoc(collection(db, "widget_crashes"), {
        error: error.toString(),
        componentStack: errorInfo.componentStack,
        timestamp: serverTimestamp(),
        type: "GlobalCrash"
      });
    } catch (e) {
      console.error("Failed to log crash", e);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 999999,
          background: 'red',
          color: 'white',
          padding: '20px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          maxWidth: '300px'
        }}>
          <h3>Widget Fatal Crash!</h3>
          <p style={{ fontSize: '12px', wordBreak: 'break-all' }}>{this.state.error && this.state.error.toString()}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById('talisman-ai-widget')).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </StrictMode>,
)
